import { Link } from 'react-router-dom';
import type { Article } from '@/types';

export default function ArticleCard({ article, featured }: { article: Article; featured?: boolean }) {
  return (
    <Link
      to={`/article/${article.id}`}
      className={`group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 ${
        featured ? 'lg:flex' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${featured ? 'lg:w-2/5 lg:shrink-0' : ''}`}>
        <div className={featured ? 'h-48 lg:h-full' : 'h-48'}>
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 whitespace-nowrap">
          {article.category === 'news' ? '最新动态' :
           article.category === 'works' ? '代表作品' :
           article.category === 'profile' ? '个人资料' : '粉丝应援'}
        </span>
      </div>
      <div className={`p-5 ${featured ? 'lg:w-3/5 lg:flex lg:flex-col lg:justify-center' : ''}`}>
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
          <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
          <span><i className="ri-user-line mr-1"></i>{article.author}</span>
        </div>
        <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2 ${
          featured ? 'text-lg md:text-xl' : 'text-base'
        }`}>
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {article.tags.map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}